// GA4 conversion tracking helper. gtag.js is loaded in public/index.html;
// calls are no-ops if it has not loaded yet (e.g. dev without network).
export const trackEvent = (name, params = {}) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }
};
